module.exports = __webpack_public_path__ + "img/02-ui-hero-mockup.5027caab.webp";